export const campusSelect = (element, id) => {
  const campus = element?.filter((e) => e._id === id);

  if (campus[0]) {
    return campus[0].location;
  }

  return [];
};
